import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	cardsTitle: {
		id: 'custom-sites-extensions.cards.hub-element.title',
		defaultMessage: 'Cards',
		description: 'A visible text label to be used as the title for the cards element',
	},
	cardsDescription: {
		id: 'custom-sites-extensions.cards.hub-element.description',
		defaultMessage: 'Present links, images and more',
		description: 'A visible text label to be used as the description for the cards element',
	},
});
